import { Environment } from '@rhg/constants';
import { createAmplitudeDestination } from './amplitude';
import { createDebugDestination } from './debug';
import { AnalyticsDestination } from './types';

interface AnalyticsDestinationProps {
    amplitudeToken: string;
    amplitudeBaseUrl: string;
    env: Environment;
    debug?: boolean;
}

export function createDestinations({
    amplitudeToken,
    amplitudeBaseUrl,
    env,
    debug = false,
}: AnalyticsDestinationProps): AnalyticsDestination[] {
    const destinations = [];
    if (amplitudeToken && amplitudeBaseUrl) {
        destinations.push(
            createAmplitudeDestination(amplitudeToken, env, amplitudeBaseUrl)
        );
    }
    if (debug) {
        destinations.push(createDebugDestination());
    }
    return destinations;
}
